import React, { Component } from "react";
import styles from "./PreparePresentation.local.scss";
import classnames from "classnames";
import { ACCESS_KEY_DURATION_OPTIONS } from "Config";
import { TiArrowSortedDown } from "react-icons/ti";
import { connect } from "react-redux";
import { setAccessKeyDuration } from "Actions";
import { generatePresentationAccessKey } from "Thunks";
import { dateFormat, onSuccess, onError } from "Utils";
import { TTP_DASHBOARD_URL } from "Config";
import _ from "i18n";
import browserHistory from "history/createBrowserHistory";

class GeneratedUrlConfig extends Component {
  constructor(props) {
    super(props);

    this.state = {
      copied: false,
      durationsFilterIsVisible: false
    };
  }
  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideDurationsFilter.bind(this)
    );
  }
  setDurationsWrapperRef = node => {
    this.durationsWrapperRef = node;
  };
  handleClickOutsideDurationsFilter = event => {
    if (
      this.durationsWrapperRef &&
      !this.durationsWrapperRef.contains(event.target)
    ) {
      this.setState({ durationsFilterIsVisible: false });
    }
  };
  handleDisplayDurationsFilter = () => {
    this.setState(state => {
      return {
        durationsFilterIsVisible: !state.durationsFilterIsVisible
      };
    });
  };
  renderUrlInput = () => {
    const {
      data: { key, expires, target },
      lng,
      years
    } = this.props;
    let { copied } = this.state;

    let year = browserHistory().location.search;
    year && year.includes("year")
      ? (year = year.replace("?year=", "").slice(0, 4))
      : (year = years[0]);

    let generatedUrl = key
      ? TTP_DASHBOARD_URL +
        "/presentation/" +
        target +
        "?year=" +
        year +
        "&&access_key=" +
        key
      : null;

    return (
      <div className={styles.input_link_container}>
        <span className={styles.title}>{_("linkPresentation")}</span>
        <input
          id={"generatedUrl"}
          className={styles.input_link}
          placeholder={"Aucun lien généré..."}
          value={generatedUrl ? generatedUrl : null}
          disabled={true}
        />
        {generatedUrl ? (
          <img
            alt={""}
            src={copied ? "/img/icons/check.svg" : "/img/icons/copy.svg"}
            onClick={() => this.handleCopyUrl()}
          />
        ) : (
          ""
        )}
        <span className={styles.validity_span}>
          {expires ? _("finalDateValidationLink") : ""}
          {expires ? <span>&nbsp;{dateFormat(expires, lng)}</span> : ""}
        </span>
      </div>
    );
  };

  handleCopyUrl = () => {
    let copyText = document.getElementById("generatedUrl");
    copyText.disabled = false;
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
    copyText.disabled = true;
    this.setState({ copied: true });
    setTimeout(() => {
      this.setState({ copied: false });
    }, 1000);
  };

  onChangeSelectedDuration = duration => {
    const { dispatch } = this.props;
    dispatch(setAccessKeyDuration(duration));
    this.setState({
      durationsFilterIsVisible: false
    });
  };

  renderGenerateSelect = () => {
    const {
      duration,
      saving,
      data: { key }
    } = this.props;
    let { durationsFilterIsVisible } = this.state;
    return (
      <div className={styles.generate_link_container}>
        {/* TODO translation */}
        <span className={styles.title}>{_("periodValidationLink")}</span>
        <div
          ref={this.setDurationsWrapperRef.bind(this)}
          className={
            styles.duration_select +
            " " +
            (durationsFilterIsVisible ? styles.duration_select_opened : "")
          }
        >
          <div className={styles.duration_select_header}>
            <span>{this.props.duration ? this.props.duration.label : ""}</span>
            <div className={styles.actions}>
              <div>
                <span
                  className={styles.action}
                  onClick={this.handleDisplayDurationsFilter}
                >
                  <TiArrowSortedDown />
                </span>
              </div>
            </div>
          </div>
          {durationsFilterIsVisible && (
            <div className={styles.duration_select_body}>
              <div className={styles.duration_select_body_options}>
                {ACCESS_KEY_DURATION_OPTIONS.map((item, index) => (
                  <div
                    key={index}
                    className={styles.duration_select_body_option}
                    onClick={() => this.onChangeSelectedDuration(item)}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <span
          className={classnames(
            styles.transparent_btn,
            styles.span_btn,
            !duration ? styles.disabled : ""
          )}
          onClick={() => this.handleGenerateAccessKey()}
        >
          <img
            src={"/img/icons/tail-spin.svg"}
            alt={""}
            className={saving ? styles.loading : ""}
          />
          {/* TODO */}
          {key ? _("regenerate") : _("generate")}
        </span>
      </div>
    );
  };

  handleGenerateAccessKey = () => {
    const { organization, dispatch, duration } = this.props;

    if (!duration) {
      return null;
    }
    let year = browserHistory().location.search;
    let period;
    year && year.includes("year")
      ? (period = year.replace("?year=", "").slice(0, 4))
      : (period = null);

    dispatch(generatePresentationAccessKey(organization.uen, period)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          // TODO tr
          body: _("Lien partageable de la présentation généré")
        });
        dispatch(setAccessKeyDuration(null));
      },
      err =>
        onError(
          err.response && err.response.data.errors
            ? err.response.data.errors[0].message
            : "errorOccured"
        )
    );
  };

  render() {
    return (
      <div className={styles.generated_url_config}>
        <div className={styles.config_block}>
          {this.renderUrlInput()}
          {this.renderGenerateSelect()}
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  saving: state.accessKey.saving,
  duration: state.accessKey.duration,
  data: state.accessKey.data,
  lng: state.params.lng,
  organization: state.dashboard.organization,
  years: state.dashboard.data.extraInfos.years
});

export default connect(mapStateToProps)(GeneratedUrlConfig);



// WEBPACK FOOTER //
// ./src/components/PreparePresentation/GeneratedURLConfig.js